(function(){
  const KEY='vivonu_delivery_location_v2';
  const dialog=document.getElementById('VivonuDeliveryLocationDialog');
  if(!dialog) return;
  // Move dialog to body so transformed/sticky header ancestors cannot clip the fixed overlay.
  if(dialog.parentElement!==document.body) document.body.appendChild(dialog);
  const panel=dialog.querySelector('.vivonu-delivery-location__panel');
  const status=dialog.querySelector('[data-vdl-status]');
  const form=dialog.querySelector('[data-vdl-form]');
  const address=form?.querySelector('[name="address"]');
  const postal=form?.querySelector('[name="postal"]');
  let lastTrigger=null;

  function openDialog(trigger){
    lastTrigger=trigger||document.activeElement;
    dialog.hidden=false;
    document.documentElement.classList.add('vivonu-location-open');
    requestAnimationFrame(()=>dialog.querySelector('.vivonu-delivery-location__close')?.focus());
  }
  function closeDialog(){
    dialog.hidden=true;
    document.documentElement.classList.remove('vivonu-location-open');
    lastTrigger?.focus?.();
  }
  function restore(){
    try{
      const saved=JSON.parse(localStorage.getItem(KEY)||'null');
      if(saved){
        if(address && saved.address) address.value=saved.address;
        if(postal && saved.postal) postal.value=saved.postal;
      }
    }catch(e){}
  }
  function save(){
    try{
      localStorage.setItem(KEY,JSON.stringify({
        address:address?.value?.trim()||'',
        postal:postal?.value?.trim()||'',
        savedAt:Date.now()
      }));
    }catch(e){}
  }

  document.addEventListener('click',e=>{
    const trigger=e.target.closest('.vivonu-delivery-location-trigger');
    if(trigger){e.preventDefault();openDialog(trigger);return;}
    if(e.target.closest('[data-vdl-close]')){e.preventDefault();closeDialog();}
  });

  dialog.addEventListener('keydown',e=>{ if(e.key==='Escape') closeDialog(); });
  panel?.addEventListener('click',e=>e.stopPropagation());

  form?.addEventListener('submit',e=>{
    e.preventDefault();
    save();
    if(status) status.textContent='Location details saved. Your exact shipping address will still be confirmed securely at checkout.';
    setTimeout(closeDialog,650);
  });

  dialog.querySelector('[data-vdl-geo]')?.addEventListener('click',()=>{
    if(!navigator.geolocation){
      if(status) status.textContent='Location detection is not supported by this browser. Please select your country and enter an address or postcode.';
      return;
    }
    if(status) status.textContent='Detecting your location…';
    navigator.geolocation.getCurrentPosition(pos=>{
      try{
        const current=JSON.parse(localStorage.getItem(KEY)||'{}');
        current.latitude=Number(pos.coords.latitude.toFixed(5));
        current.longitude=Number(pos.coords.longitude.toFixed(5));
        current.accuracy=Math.round(pos.coords.accuracy||0);
        current.savedAt=Date.now();
        localStorage.setItem(KEY,JSON.stringify(current));
      }catch(e){}
      if(status) status.textContent='Location permission received. Your selected country controls the storefront market and the linked display currency. Confirm or change the country above if needed.';
    },()=>{
      if(status) status.textContent='We could not access your location. You can still select your country and enter an address or postcode.';
    },{enableHighAccuracy:false,timeout:8000,maximumAge:300000});
  });

  /* Vivonu unified location → currency handoff */
  const countrySelect=document.getElementById('VivonuLocationCountry');
  countrySelect?.addEventListener('change',()=>{
    const option=countrySelect.selectedOptions?.[0];
    const text=(option?.textContent||'').trim();
    const match=text.match(/(?:·|\\s)([A-Z]{3})\\s*$/);
    const currency=(match?.[1]||'').toUpperCase();
    const countryName=text.split('·')[0]?.trim()||'';
    if(status&&currency){
      status.textContent='Selected '+countryName+'. After Update country, Vivonu will display prices in '+currency+' while checkout remains in ZAR unless checkout states otherwise.';
    }
  });

  const countryForm=document.getElementById('VivonuLocationCountryForm');
  countryForm?.addEventListener('submit',()=>{
    try{
      const option=countrySelect?.selectedOptions?.[0];
      const text=(option?.textContent||'').trim();
      const match=text.match(/(?:·|\\s)([A-Z]{3})\\s*$/);
      localStorage.setItem('vivonu_next_display_currency',(match?.[1]||'').toUpperCase());
    }catch(e){}
  });


  restore();
})();

/* Vivonu searchable country selector with flags — 2026-10-08 */
(function(){
  'use strict';

  function flagEmoji(code){
    const cc=String(code||'').trim().toUpperCase();
    if(!/^[A-Z]{2}$/.test(cc)) return '🌍';
    return String.fromCodePoint(...[...cc].map(c=>127397+c.charCodeAt(0)));
  }

  function flagMarkup(code){
    const cc=String(code||'').trim().toUpperCase();
    if(!/^[A-Z]{2}$/.test(cc)) return '<span class="vivonu-country-flag-fallback" aria-hidden="true">🌍</span>';
    const lower=cc.toLowerCase();
    return '<img class="vivonu-country-flag-img" src="https://flagcdn.com/w160/'+lower+'.png" srcset="https://flagcdn.com/w320/'+lower+'.png 2x" alt="" aria-hidden="true" decoding="async">';
  }

  function parseOption(option){
    const raw=(option?.textContent||'').trim();
    const parts=raw.split('·').map(s=>s.trim()).filter(Boolean);
    return {
      code:(option?.value||'').toUpperCase(),
      country:parts[0]||raw,
      currency:(parts[1]||'').toUpperCase()
    };
  }

  function initCountryCombobox(){
    const select=document.getElementById('VivonuLocationCountry');
    if(!select || select.dataset.vivonuSearchReady==='true') return;

    const wrapper=document.createElement('div');
    wrapper.className='vivonu-country-combobox';
    wrapper.innerHTML=`
      <button type="button" class="vivonu-country-combobox__button" aria-haspopup="listbox" aria-expanded="false">
        <span class="vivonu-country-combobox__flag" aria-hidden="true"></span>
        <span class="vivonu-country-combobox__button-copy">
          <strong class="vivonu-country-combobox__country"></strong>
          <small class="vivonu-country-combobox__currency"></small>
        </span>
        <span class="vivonu-country-combobox__chevron" aria-hidden="true">⌄</span>
      </button>
      <div class="vivonu-country-combobox__menu" hidden>
        <div class="vivonu-country-combobox__search-wrap">
          <span class="vivonu-country-combobox__search-icon" aria-hidden="true">⌕</span>
          <input class="vivonu-country-combobox__search" type="search" autocomplete="off" placeholder="Search country or region" aria-label="Search country or region">
        </div>
        <div class="vivonu-country-combobox__list" role="listbox" aria-label="Countries and regions"></div>
        <div class="vivonu-country-combobox__empty" hidden>No matching country or region.</div>
      </div>
    `;

    select.insertAdjacentElement('afterend',wrapper);
    select.classList.add('vivonu-country-select--enhanced');
    select.dataset.vivonuSearchReady='true';

    const trigger=wrapper.querySelector('.vivonu-country-combobox__button');
    const flag=wrapper.querySelector('.vivonu-country-combobox__flag');
    const country=wrapper.querySelector('.vivonu-country-combobox__country');
    const currency=wrapper.querySelector('.vivonu-country-combobox__currency');
    const menu=wrapper.querySelector('.vivonu-country-combobox__menu');
    const search=wrapper.querySelector('.vivonu-country-combobox__search');
    const list=wrapper.querySelector('.vivonu-country-combobox__list');
    const empty=wrapper.querySelector('.vivonu-country-combobox__empty');
    const marketPanel=wrapper.closest('.vivonu-delivery-location__market');
    // Keep the dropdown in the localization form's grid so it pushes the address section down.
    const countryForm=select.closest('form');
    if(countryForm) countryForm.appendChild(menu);

    function syncTrigger(){
      const data=parseOption(select.selectedOptions?.[0]);
      flag.innerHTML=flagMarkup(data.code);
      country.textContent=data.country;
      currency.textContent=data.currency ? data.currency+' · Local pricing' : 'Local pricing';
    }

    function closeMenu(refocus){
      menu.hidden=true;
      trigger.setAttribute('aria-expanded','false');
      wrapper.classList.remove('is-open');
      marketPanel?.classList.remove('country-menu-open');
      if(refocus) trigger.focus();
    }

    function openMenu(){
      menu.hidden=false;
      trigger.setAttribute('aria-expanded','true');
      wrapper.classList.add('is-open');
      marketPanel?.classList.add('country-menu-open');
      search.value='';
      filter('');
      requestAnimationFrame(()=>search.focus({preventScroll:true}));
      // Do not scroll the entire modal/page when the list opens.
      list.scrollTop=0;
    }

    function choose(code){
      if(!code) return;
      select.value=code;
      select.dispatchEvent(new Event('change',{bubbles:true}));
      list.querySelectorAll('.vivonu-country-combobox__option').forEach(btn=>{
        btn.setAttribute('aria-selected',btn.dataset.code===code?'true':'false');
      });
      syncTrigger();
      closeMenu(true);
    }

    function buildList(){
      list.innerHTML='';
      [...select.options].forEach(option=>{
        const data=parseOption(option);
        const btn=document.createElement('button');
        btn.type='button';
        btn.className='vivonu-country-combobox__option';
        btn.dataset.code=data.code;
        btn.dataset.search=(data.country+' '+data.currency+' '+data.code).toLowerCase();
        btn.setAttribute('role','option');
        btn.setAttribute('aria-selected',option.selected?'true':'false');
        btn.innerHTML=`
          <span class="vivonu-country-combobox__option-flag" aria-hidden="true">${flagMarkup(data.code)}</span>
          <span class="vivonu-country-combobox__option-copy">
            <strong>${data.country.replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]))}</strong>
            <small>${(data.currency||'Local pricing').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]))}</small>
          </span>
          <span class="vivonu-country-combobox__check" aria-hidden="true">✓</span>
        `;
        btn.addEventListener('click',()=>choose(data.code));
        list.appendChild(btn);
      });
    }

    function filter(term){
      const q=String(term||'').trim().toLowerCase();
      let count=0;
      list.querySelectorAll('.vivonu-country-combobox__option').forEach(btn=>{
        const show=!q || btn.dataset.search.includes(q);
        btn.hidden=!show;
        if(show) count++;
      });
      empty.hidden=count>0;
    }

    trigger.addEventListener('click',()=>{
      if(menu.hidden) openMenu();
      else closeMenu(false);
    });
    trigger.addEventListener('keydown',e=>{
      if(e.key==='ArrowDown'||e.key==='Enter'||e.key===' '){
        e.preventDefault();
        if(menu.hidden) openMenu();
      }
      if(e.key==='Escape') closeMenu(false);
    });
    search.addEventListener('input',()=>{filter(search.value);list.scrollTop=0;});
    search.addEventListener('keydown',e=>{
      if(e.key==='Escape'){e.preventDefault();closeMenu(true);return;}
      if(e.key==='ArrowDown'){
        e.preventDefault();
        list.querySelector('.vivonu-country-combobox__option:not([hidden])')?.focus();
      }
    });
    list.addEventListener('keydown',e=>{
      const current=e.target.closest('.vivonu-country-combobox__option');
      if(!current) return;
      const visible=[...list.querySelectorAll('.vivonu-country-combobox__option:not([hidden])')];
      const i=visible.indexOf(current);
      if(e.key==='ArrowDown'){e.preventDefault();visible[Math.min(i+1,visible.length-1)]?.focus();}
      if(e.key==='ArrowUp'){e.preventDefault();(i<=0?search:visible[i-1])?.focus();}
      if(e.key==='Escape'){e.preventDefault();closeMenu(true);}
    });
    document.addEventListener('pointerdown',e=>{
      if(!wrapper.contains(e.target) && !menu.contains(e.target) && !menu.hidden) closeMenu(false);
    });

    select.addEventListener('change',syncTrigger);
    buildList();
    syncTrigger();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initCountryCombobox,{once:true});
  else initCountryCombobox();
})();